import { combineReducers } from "redux"
import { AppReducer } from "src/App/App.reducer"
import { loginReducer } from "src/pages/Login/Login.reducer"
import { SideMenuReducer } from "./sidemenu/sidemenu.reducer"
import ThemeOptions from "./ThemeOptions"
const initialReducer = {
  app: AppReducer,
  login: loginReducer,
  sidemenu: SideMenuReducer,
  ThemeOptions,
}
const rootReducer = combineReducers(initialReducer)
export { initialReducer }
export default rootReducer
